import ErrorModal from './error-modal.vue';

export default ErrorModal;
